import { render, staticRenderFns } from "./CardPosicaoAtual.vue?vue&type=template&id=43181df0&"
import script from "./CardPosicaoAtual.vue?vue&type=script&lang=js&"
export * from "./CardPosicaoAtual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports